<template>
  <div class="question-view ">
    <div class="quest">
      <div class="title">
        <vue-mathjax :formula="form.title" @onRenderComplete="mathjaxRes" :safe="false"/>
      </div>
      <div class="btn-list">
        <div class="single">
          <!-- <span class="true-icon"></span> -->
          正確
        </div>
        <div class="single">
          <!-- <span class="false-icon"></span> -->
          錯誤
        </div>
      </div>
    </div>
    <div class="quest-img" v-if="form.img_url">
      <img :src="form.img_url" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props: ['form'],
  data() {
    return {
      image: '',
      topic: '',
      trueFlase: '',
    }
  },
  methods: {
    mathjaxRes() {
      // console.log('判断题')
      this.$emit('onRenderComplete')
    }
  },
  // mounted() {
  //   let content = JSON.parse(this.form.content)
  //   console.log(content)
  // }
}
</script>

<style scoped lang="scss">
.question-view {
  width: 100%;
  height: 100%;
  padding: 0px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 10px;
  .quest {
    // width: calc(55% - 10px);
    flex: 1;
    height: 100%;
    .title {
      font-size: 18px;
      color: #333;
    }
    .btn-list {
      width: calc(55% - 10px);
      margin-top: 20px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .single {
        width: calc(50% - 10px);
        padding: 10px;
        box-sizing: border-box;
        border-radius: 10px;
        border: 2px solid #fcd2ab;
        background-color: #fcd2ab;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        margin-bottom: 10px;
        cursor: pointer;
        font-weight: 700;
        font-size: 18px;
        color: #333;
        .true-icon {
          position: relative;
          width: 20px;
          height: 20px;
          
          &:after {
            position: absolute;
            content: '';
            width: 20px;
            height: 10px;
            border: 4px solid #f6a053;
            border-top-color: transparent;
            border-right-color: transparent;
            border-radius: 2px;
          }
        }

        &:hover {
          opacity: .8;
        }
      }
    }
  }
  .quest-img {
    width: 500px;
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
      border-radius: 5px;
    }
  }
}
</style>